import * as React from 'react';
import { Button, Checkbox, Divider, Form, Header, Icon, List, Menu, Modal } from 'semantic-ui-react';
import { Direction } from '~/Api';
import { ColumnQuery } from '~/Api/ColumnQuery';
import { ColumnRequest, Comparison, DataType, } from '~/Api/Report';
import { CustomizeReportRowCountRequest, } from '~/Api/Report/CustomizeReportRowCount';
import { useApiResult, useApiResults } from '~/ApiHooks';
import { useCurrentOrLastSuccesfullApiResultValue } from '~/ApiHooks/useApiResult';
import { BetaLabel } from '~/BetaLabel';
import { MessageType, useFlashMessage } from '~/FlashMessage';
import { fromUserFormat } from '~/Report/DecimalFormatter';
import { InfiniteScroll, Placeholder } from '~/UI';
var Checkboxes = React.memo(function (_a) {
    var filterColumn = _a.filterColumn, comparison = _a.comparison, columnFilters = _a.columnFilters, column = _a.column, header = _a.header;
    return (<List style={{ padding: '0' }}>
		{column.map(function (column, index) { return (<List.Item key={index}>
				<Checkbox checked={(comparison === Comparison.notEqual && columnFilters.find(function (el) { return el.value === column; }) === undefined) ||
                (comparison === Comparison.equal && columnFilters.find(function (el) { return el.value === column; }) !== undefined)} data-testid='filter-checkbox' label={column} onClick={function () {
                filterColumn(header, column, comparison);
            }}/>
			</List.Item>); })}
	</List>);
});
export var ColumnSettings = function (_a) {
    var revealColumn = _a.revealColumn, removeSort = _a.removeSort, originalReport = _a.originalReport, removeColumnFilters = _a.removeColumnFilters, sortColumn = _a.sortColumn, hideColumn = _a.hideColumn, headerId = _a.headerId, header = _a.header, selectColumn = _a.selectColumn, searchParams = _a.searchParams, filterColumn = _a.filterColumn, onSubmitChanges = _a.onSubmitChanges;
    var _b = React.useState(''), inputValue = _b[0], setInputValue = _b[1];
    var _c = React.useState(originalReport), editedReport = _c[0], setEditedReport = _c[1];
    var _d = React.useState(true), allChecked = _d[0], setAllChecked = _d[1];
    var _e = useFlashMessage(), setFlashMessage = _e[1];
    var countResult = useApiResult(new CustomizeReportRowCountRequest(editedReport.id, editedReport.isCustom, editedReport.reportSettings), [
        editedReport,
    ])[0];
    var someResultValue = useCurrentOrLastSuccesfullApiResultValue(countResult);
    var handleColumFilter = React.useCallback(function (header, data, comparison) {
        setEditedReport(filterColumn(editedReport, header, data, comparison));
    }, [fromUserFormat, editedReport]);
    var handleRemoveColumnFilter = React.useCallback(function (headerId) {
        setEditedReport(removeColumnFilters(editedReport, headerId));
    }, [removeColumnFilters, editedReport]);
    var comparison = React.useMemo(function () {
        return editedReport.getComparison(header.id) === Comparison.notEqual && allChecked
            ? Comparison.notEqual
            : Comparison.equal;
    }, [allChecked, editedReport]);
    var searchValue = function (e) {
        setTimeout(function () {
            setInputValue(e.target.value);
        }, 500);
    };
    var _f = React.useState(Direction.asc), direction = _f[0], setDirection = _f[1];
    var switchComparison = function () {
        if (editedReport.isFiltered(header.id) && comparison === Comparison.notEqual) {
            handleRemoveColumnFilter(header.id);
            return;
        }
        handleRemoveColumnFilter(header.id);
        setAllChecked(!allChecked);
    };
    var _g = useApiResults(function (lastResponse) {
        var _a;
        return (lastResponse === null || lastResponse.pagination.currentPage < lastResponse.pagination.totalPages) &&
            header.id !== ''
            ? new ColumnRequest(editedReport.id, editedReport.isCustom, header.id, new ColumnQuery(((_a = lastResponse === null || lastResponse === void 0 ? void 0 : lastResponse.pagination.currentPage) !== null && _a !== void 0 ? _a : 0) + 1, direction, inputValue, searchParams.get('data-version-id')))
            : null;
    }, [editedReport.id, header.id, inputValue, direction]), column = _g[0], loadNext = _g[1];
    var handleSort = function (direction) {
        if (editedReport.getSort(header.id) !== direction) {
            setEditedReport(sortColumn(editedReport, { property: header.id, direction: direction }));
        }
        else {
            setEditedReport(removeSort(editedReport, header.id));
        }
    };
    var handleHide = function () {
        if (editedReport.isHidden(header.id)) {
            setEditedReport(revealColumn(editedReport, header));
        }
        else {
            setEditedReport(hideColumn(editedReport, header));
        }
    };
    var handleSumit = function () {
        if (comparison === Comparison.equal &&
            editedReport.columnFilters.find(function (column) { return column.columnName === header.id; }) === undefined) {
            setFlashMessage({
                subtext: 'Vyberte alespoň jednu možnost',
                text: 'Chyba:',
                type: MessageType.error,
            });
            return;
        }
        setInputValue('');
        selectColumn('');
        onSubmitChanges(editedReport);
    };
    var handleCancel = function () {
        setInputValue('');
        selectColumn('');
    };
    var wereChangesMade = originalReport !== editedReport;
    return (<Modal icon={null} open={headerId === header.id && header.id !== ''} onClose={handleCancel}>
			<Modal.Header>{header.title}</Modal.Header>
			<Modal.Content>
				<Header as='h5'>Obecné nastavení reportu</Header>
				<Menu widths={3}>
					<Menu.Item active={editedReport.getDefaultSort(header.id) === Direction.asc ||
            editedReport.getSort(header.id) === Direction.asc} data-testid='sort-asc' onClick={function () {
            handleSort(Direction.asc);
        }}>
						{header.dataType === DataType.text ? 'Seřadit od A-Z' : 'Seřadit od nejmenšího'}
					</Menu.Item>
					<Menu.Item active={editedReport.getDefaultSort(header.id) === Direction.desc ||
            editedReport.getSort(header.id) === Direction.desc} data-testid='sort-desc' onClick={function () {
            handleSort(Direction.desc);
        }}>
						{header.dataType === DataType.text ? 'Seřadit od Z-A' : 'Seřadit od největšího'}
					</Menu.Item>
					<Menu.Item active={editedReport.isHidden(header.id)} data-testid='hide' onClick={handleHide}>
						Skrýt sloupec
					</Menu.Item>
				</Menu>

				<Divider />
				<Form>
					<Header.Content as='h5'>
						Filtr a nastavení vybraného sloupce
						<BetaLabel />
					</Header.Content>
					<Form.Field>
						<Form.Group>
							<Form.Input autoFocus data-testid='filter' width='15' onChange={function (e) {
            searchValue(e);
        }}/>
							<Button compact floated='right' size='mini' onClick={function () {
            var nextDirection = direction === Direction.asc ? Direction.desc : Direction.asc;
            setDirection(nextDirection);
        }}>
								{header.dataType === DataType.text ? (<Icon fitted name={direction === Direction.asc ? 'sort alphabet down' : 'sort alphabet up'}/>) : (<Icon fitted name={direction === Direction.asc ? "sort numeric down" : "sort numeric up"}/>)}
							</Button>
						</Form.Group>
					</Form.Field>

					<Divider />
					<Checkbox checked={allChecked && !editedReport.isFiltered(header.id)} data-testid='all-checkbox' label={'Vyber všechny řádky'} onClick={function () {
            switchComparison();
        }}/>
					<span style={{ float: 'right' }}>
						Počet řádků:{' '}
						<span style={{ display: 'inline-block', minWidth: '35px' }}>
							{(someResultValue === null || someResultValue === void 0 ? void 0 : someResultValue.rowsCount) === undefined ? ' ' : someResultValue === null || someResultValue === void 0 ? void 0 : someResultValue.rowsCount}
						</span>
					</span>
					<Divider />
					<div style={{ height: '35vh' }}>
						<List style={{ height: '100%', overflowY: 'scroll' }}>
							<InfiniteScroll marginTop='0' onLoad={loadNext}>
								{column.isLoading && column.value === null ? <Placeholder /> : null}
								{column.value !== null
            ? column.value.map(function (column, index) { return (<Checkboxes column={column.items} columnFilters={editedReport.columnFilters} comparison={comparison} filterColumn={handleColumFilter} header={header} key={index}/>); })
            : null}
							</InfiniteScroll>
						</List>
					</div>
					<div style={{ padding: '1em 0 3em' }}>
						<Button negative data-testid='cancel-settings' floated='left' onClick={handleCancel}>
							Zrušit změny
						</Button>
						<Button primary data-testid='submit-settings' disabled={!wereChangesMade} floated='right' onClick={handleSumit}>
							Uložit změny
						</Button>
					</div>
				</Form>
			</Modal.Content>
		</Modal>);
};
ColumnSettings.displayName = 'ColumnSettings';
